<template>
  <div id="wrap">
    <!-- 본문 영역 시작-->
    <div id="contract_container">
      <div class="contract_contents">
        <div class="compensation1_area_1">
          <img src="../../assets/img/pass6.png" alt="해지">
          <h2>서비스 해지하기</h2>
          <h3>가입자 정보를 정확히 입력하시기 바랍니다.</h3>
          <v-form v-model="valid" ref="form" onsubmit="return false;">
            <fieldset>
              <table>
                <tr>
                  <td>
                    <h4>통신사</h4>
                  </td>
                  <td>
                    <v-radio-group v-model="teleCoCd" hide-details row style="margin-top:8px;">
                      <v-radio label="SKT" value="1"></v-radio>
                      <v-radio label="KT" value="2"></v-radio>
                      <v-radio label="LGU+" value="3"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label for="name">이름</label>
                  </td>
                  <td>
                    <v-text-field
                      style="font-size: 0.75rem; width:200px; padding-top: 0px; vertical-align: middle; height: 42px;"
                      v-model="name"
                      :rules="rules.nameRules"
                      label="이름"
                      single-line
                      color="accent"
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label for="birth">생년월일</label>
                  </td>
                  <td>
                    <v-text-field
                      style="font-size: 0.75rem; width:200px; padding-top: 0px; vertical-align: middle; height: 42px;"
                      v-model="birth"
                      :rules="rules.birthRules"
                      label="19990101"
                      mask="########"
                      single-line
                      color="accent"
                    ></v-text-field>
                    <!-- <div class="gender480">
                      <v-radio-group v-model="genCd" hide-details style="margin-top:8px;">
                        <v-radio label="남" value="M"></v-radio>
                        <v-radio label="여" value="F"></v-radio>
                      </v-radio-group>
                    </div> -->
                  </td>
                </tr>
                <tr>
                  <td>
                    <label for="genCd">성별</label>
                  </td>
                  <td>
                    <div>
                      <v-radio-group v-model="genCd" hide-details row style="margin-top:8px;">
                        <v-radio label="남" value="M"></v-radio>
                        <v-radio label="여" value="F"></v-radio>
                      </v-radio-group>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label for="tel">휴대폰번호</label>
                  </td>
                  <td>
                    <v-text-field
                      style="font-size: 0.75rem; width:200px; padding-top: 0px; vertical-align: middle; height: 42px;"
                      v-model="cellTelNo"
                      :rules="rules.cellTelNoRules"
                      label="'-'를 제외하고 입력"
                      mask="###########"
                      single-line
                      color="accent"
                    ></v-text-field>
                  </td>
                </tr>
              </table>
              <!-- 버튼영역시작 -->
              <div style="margin:0 auto;text-align: center; width:303px;">
                <vue-recaptcha
                  ref="recaptcha"
                  v-model="recaptchaVerify"
                  @verify="onVerify"
                  @expired="onExpired"
                  :sitekey="$cfg.recaptchaSiteKey"
                ></vue-recaptcha>
                  <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" v-if="!recaptchaVerifyCheck" style="text-align: left;">로봇이 아닙니다를 체크하세요!</div>
                    </div>
                  </div>
                </div>
              <div class="form_btn" style="margin-top:10px;">
                <v-btn
                  id="join_btn"
                  style="color:#fff; font-size:16px margin-left: 0px !improtant"
                  color="#007bff"
                  v-on:click="submit"
                >해지하기</v-btn>
                <v-btn
                  id="back_btn"
                  style="color:#fff; font-size:16px margin-left: 0px !improtant"
                  color="#dc3545"
                  @click.stop="$router.push({name: 'passSafeguardCs'})"
                >돌아가기</v-btn>
              </div>
              <!-- 버튼영역 끝 -->
            </fieldset>
          </v-form>
        </div>
      </div>
    </div>
    <!-- 본문 영역 끝-->
  </div>
</template>
<script>
import {GaTracking} from "@/mixins/index.js";

export default {
  mixins: [GaTracking],
  name: "app",

  data: () => ({
    valid: false,
    recaptchaVerify: false,
    recaptchaVerifyCheck: true,
    teleCode: "1", //통신사구분코드
    name: "", // 이름
    birth: "", // 생년월일
    genCd: "M", // 성별코드
    cellTelNo: "", // 전화번호
    rules: {
      nameRules: [v => !!v || "이름을 입력하세요."],
      birthRules: [
        v => !!v || "생년월일을 입력하세요.",
        v => (v && v.length >= 8 && /((1|2)[0-9]{3})(0[1-9]{1}|1[0-2]{1})(0[1-9]|(1|2)[0-9]{1}|3[0-1]{1})$/.test(v)) || "생년월일이 정확하지 않습니다."
      ],
      cellTelNoRules: [
        v => !!v || "휴대폰번호를 입력하세요.",
        v =>
          (v &&
            v.length >= 11 &&
            /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v)) ||
          "휴대폰번호가 정확하지 않습니다."
      ]
    }
  }),
  computed: {
    teleCoCd() {
      const codeMap = {
        '7': '3',
        '8': '2'
      };

      return codeMap[this.teleCode] || this.teleCode;
    },
    form() {
      return {
        name: this.name,
        birth: this.birth,
        cellTelNo: this.cellTelNo
      };
    }
  },
  methods: {
    // 해지처리
    submit() {
      this.recaptchaVerifyCheck = this.recaptchaVerify
      this.$refs.form.validate();
      //   console.log("this.valid", this.valid);
      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }

      this.$router.push({
        name: "passSafeGuardCert",
        params: {
          type: "termination",
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          name: this.name,
          birth: this.birth,
          genCd: this.genCd
        }
      });
    },
    //vue-recaptcha
    onVerify(r) {
      // console.log(r);
      this.recaptchaVerify = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    exec() {
      this.$refs.recaptcha.execute();
    },
    reset() {
      this.$refs.recaptcha.reset();
    },
    replaceNan(dataNm) {
      this[dataNm] = this[dataNm].replaceAll(/[^0-9]/g, "")
    }
  }
};
</script>
<style>
/* validation check color red */
.v-messages__message {
  color: #ff5252 !important;
}
.v-messages__wrapper {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
.mdi-radiobox-marked {
  color: #005df9 !important;
}
</style>